import { ReactElement, SVGProps } from 'react';
import BaseIcon from "./BaseIcon";

export default function PencilSimpleSlashIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path d="m21.179 7.012-4.19-4.19a1.313 1.313 0 0 0-1.856 0L3.572 14.382a1.3 1.3 0 0 0-.385.928v4.19A1.313 1.313 0 0 0 4.5 20.813h15.75a.563.563 0 1 0 0-1.125h-9.892L21.18 8.868a1.315 1.315 0 0 0 0-1.856M8.768 19.688H4.5a.19.19 0 0 1-.188-.188v-4.19a.2.2 0 0 1 .055-.133l8.383-8.381 4.455 4.454zM20.383 8.073 18 10.455 13.546 6l2.383-2.382a.19.19 0 0 1 .265 0l4.19 4.189a.19.19 0 0 1 0 .265" fill="currentColor"/>
    </BaseIcon>
  )
}
